import { motion } from "framer-motion";

// Full-screen backdrop that wraps the onboarding modal. Renders gradients +
// grain for cinematic depth, blocks background interaction, and forwards a
// click on the scrim to `onClose`.
export default function OnboardingBackdrop({ children, onClose }) {
  return (
    <motion.div
      data-testid="onboarding-backdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden bg-[#0B0B0E]/95 px-4 py-8 backdrop-blur-xl"
      onClick={() => onClose?.()}
    >
      {/* Layered radial gradients for cinematic depth */}
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse 70% 60% at 25% 30%, rgba(124,58,237,0.30) 0%, rgba(15,15,20,0) 60%), radial-gradient(ellipse 60% 50% at 80% 70%, rgba(34,211,238,0.22) 0%, rgba(15,15,20,0) 60%), radial-gradient(ellipse 50% 40% at 50% 90%, rgba(245,158,11,0.18) 0%, rgba(15,15,20,0) 70%)",
          }}
        />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
          className="absolute -top-32 left-1/2 h-[520px] w-[820px] -translate-x-1/2 rounded-full blur-3xl"
          style={{
            background:
              "radial-gradient(circle, rgba(124,58,237,0.18) 0%, rgba(15,15,20,0) 70%)",
          }}
        />
        <div
          className="absolute inset-0 opacity-[0.07] mix-blend-overlay"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' seed='8'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.85 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
          }}
        />
      </div>
      {children}
    </motion.div>
  );
}
